<template>
  <div class="main_form_body main_form_body_voteBasic">
    <div class="form_bar" style="align-self: flex-end; width: 100%">
      <div class="form_bar_search"></div>
      <div class="form_bar_btn">
        <el-button
          type="primary"
          @click="editVote('voteBasicForm', false)"
          size="small"
        >
          保存
        </el-button>
        <el-button
          type="primary"
          @click="editVote('voteBasicForm', true)"
          size="small"
          :disabled="voteInfo.Status !== 0"
        >
          下一步
        </el-button>
      </div>
    </div>
    <div class="form_content" style="flex-grow: 1; width: 100%">
      <div class="main_form">
        <el-form
          :model="voteBasicForm"
          :rules="voteBasicFormRules"
          ref="voteBasicForm"
          label-width="150px"
          class="demo-ruleForm"
          v-loading="editVoteLoading"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="投票名称" prop="VoteName">
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input v-model="voteBasicForm.VoteName"></el-input>
                <br />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="投票时间" v-if="meetingInfo.MeetingType === 2">
            <el-col :xs="11" :sm="8" :md="8" :lg="6" :xl="3">
              <el-form-item class="el-form-item-internal" prop="StartTime">
                <el-date-picker
                  ref="StartTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                  v-model="voteBasicForm.StartTime"
                  format="yyyy-MM-dd HH:mm"
                  default-time="9:00:00"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :xs="2" :sm="2" :md="2" :lg="1" :xl="1">
              -
            </el-col>
            <el-col :xs="11" :sm="8" :md="8" :lg="6" :xl="3">
              <el-form-item class="el-form-item-internal" prop="EndTime">
                <el-date-picker
                  ref="EndTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  v-model="voteBasicForm.EndTime"
                  format="yyyy-MM-dd HH:mm"
                  default-time="18:00:00"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="是否每天投票" prop="IsEveryDay">
            <el-switch v-model="voteBasicForm.IsEveryDay"> </el-switch>
          </el-form-item>
          <el-form-item
            label="投票规则"
            prop="RuleInfo"
            v-if="meetingInfo.MeetingType === 2"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input
                  ref="RuleInfo"
                  type="textarea"
                  rows="5"
                  maxlength="4000"
                  v-model="voteBasicForm.RuleInfo"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="投票详情"
            prop="Remark"
            v-if="meetingInfo.MeetingType === 2"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <VueUeditorWrap
                  ref="Remark"
                  v-model="voteBasicForm.Remark"
                  :config="ueditorConfig"
                ></VueUeditorWrap>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="meetingInfo.MeetingType === 2">
            <span slot="label">
              <div>投票顶部图片</div>
              <div style="font-size: 12px; line-height: 18px">
                (多张将滚动显示)
              </div>
              <div style="font-size: 12px; line-height: 18px">
                (最多5张图片)
              </div>
            </span>
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <div
                  style="
                    margin: 5px;
                    display: inline-block;
                    position: relative;
                    border: 1px solid #e6e6e6;
                    height: 100px;
                    width: 150px;
                    text-align: center;
                    border-radius: 5px;
                  "
                  v-for="(voteImage, index) in voteBasicForm.TopImages"
                  :key="index"
                >
                  <el-image
                    style="height: 100px; border-radius: 5px"
                    ref="voteImagesPreviewImage"
                    :src="voteBasicForm.DomainUrl + voteImage.ImageUrl"
                    class="preview-image"
                    fit="fill"
                    :preview-src-list="getPrivewImages(index)"
                    :z-index="3000"
                  ></el-image>
                  <el-button
                    icon="el-icon-close"
                    title="删除"
                    circle
                    type="danger"
                    style="position: absolute; right: -8px; top: -8px"
                    @click="deleteImages(index)"
                  ></el-button>
                </div>
                <el-alert
                  v-if="voteBasicForm.TopImages.length === 0"
                  :closable="false"
                >
                  暂无图片
                </el-alert>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-upload
              class="upload-demo"
              ref="voteImageUpload"
              :file-list="voteImageFiles"
              action="#"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              :limit="5"
              :http-request="voteImageHandleUpload"
              :auto-upload="false"
              :multiple="true"
            >
              <el-button size="small" type="primary">点击选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
import ueditorConfig from '../../../../assets/js/ueditorConfig'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      editVoteLoading: false,
      voteBasicForm: {
        Id: null,
        VoteName: null,
        MeetId: null,
        VoteType: null,
        StartTime: '',
        EndTime: '',
        Remark: '',
        RuleInfo: '',
        IsEveryDay: '',
        TopImages: []
      },
      rolePercent: '',
      voteBasicFormRules: {
        VoteName: [
          { required: true, message: '请输入投票名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        VoteType: [
          { required: true, message: '请选择会议类型', trigger: 'blur' }],
        StartTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        EndTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        Remark: [{ min: 0, max: 4000, message: '最多4000个字符', trigger: 'blur' }]
      },
      ueditorConfig: ueditorConfig,
      deleteImageArray: [],
      voteImageFiles: []
    }
  },
  props: ['voteInfo', 'meetingInfo'],
  inject: ['voteCheck', 'getVoteInfo', 'routeChange', 'getMeetingVoteInfo'],
  methods: {
    getPublicVoteBasicInfo: function () {
      this.editVoteLoading = true
      voteManageApi.getPublicVoteBasicInfo({
        voteId: this.$route.params.vid
      }).then(data => {
        this.voteBasicForm = data
        this.editVoteLoading = false
      }).catch(err => {
        this.editVoteLoading = false
        return err
      })
    },
    voteImageHandleUpload: function (raw) {
      const _this = this
      _this.voteImageFiles.push(raw.file)
    },
    editVote: function (formName, isNext) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = _this.openLoading('正在保存…')
          _this.$refs.voteImageUpload.submit()
          const fd = new FormData()
          fd.append('Id', _this.voteBasicForm.Id ? _this.voteBasicForm.Id : '')
          fd.append('MeetId', _this.voteBasicForm.MeetId)
          fd.append('VoteName', _this.voteBasicForm.VoteName)
          fd.append('VoteType', _this.voteBasicForm.VoteType)
          fd.append('StartTime', _this.$moment(_this.voteBasicForm.StartTime).format('YYYY-MM-DD HH:mm'))
          fd.append('EndTime', _this.$moment(_this.voteBasicForm.EndTime).format('YYYY-MM-DD HH:mm'))
          fd.append('Remark', _this.voteBasicForm.Remark ? _this.voteBasicForm.Remark : '')
          fd.append('RuleInfo', _this.voteBasicForm.RuleInfo ? _this.voteBasicForm.RuleInfo : '')
          fd.append('IsEveryDay', _this.voteBasicForm.IsEveryDay)
          if (_this.deleteImageArray) {
            fd.append('DeleteImages', JSON.stringify(_this.deleteImageArray))
          } else {
            fd.append('DeleteImages', '')
          }

          this.voteImageFiles.forEach(function (file, index) {
            fd.append('voteFiles' + index, file)
          })

          voteManageApi.editPublicVoteBasic(fd).then(data => {
            _this.voteBasicForm.Id = data.Id
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            _this.voteImageFiles = []
            openLoading.close()
            this.voteCheck()
            this.getVoteInfo()
            this.getMeetingVoteInfo()
            if (isNext) {
              _this.$router.push({ name: 'editPublicVoteProject', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id } })
            } else {
              _this.$router.push({ name: 'editPublicVoteBasic', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id } })
              this.getPublicVoteBasicInfo()
            }
          }).catch(err => {
            openLoading.close()
            return err
          })
        } else {
          return false
        }
      })
    },
    // 预览对应当前图片列表
    getPrivewImages (index) {
      const _this = this
      const imgList = []// 所有图片地址
      if (_this.voteBasicForm.TopImages.length > 0) {
        if (index === 0) {
          _this.voteBasicForm.TopImages.forEach(function (voteImage) {
            imgList.push(_this.voteBasicForm.DomainUrl + voteImage.ImageUrl)
          })
        } else {
          for (let i = index; i < _this.voteBasicForm.TopImages.length; i++) {
            imgList.push(_this.voteBasicForm.DomainUrl + _this.voteBasicForm.TopImages[i].ImageUrl)
          }
          for (let i = 0; i < index; i++) {
            imgList.push(_this.voteBasicForm.DomainUrl + _this.voteBasicForm.TopImages[i].ImageUrl)
          }
        }
      }
      return imgList
    },
    deleteImages: function (index) {
      const _this = this
      _this.deleteImageArray.push(_this.voteBasicForm.TopImages[index])
      _this.voteBasicForm.TopImages.splice(index, 1)
    }
  },
  mounted () {

  },
  created () {
    this.ueditorConfig.zIndex = 1000
    if (this.$route.params.vid === '0') {
      this.voteBasicForm.MeetId = this.$route.params.mid
    } else {
      this.getPublicVoteBasicInfo()
    }
    this.routeChange()
    this.voteCheck()
  },
  watch: {
  }
}
</script>
<style lang="less">
.el-table__row {
  cursor: pointer;
}
#selectRule .el-divider__text {
  font-size: 18px;
  font-weight: 900;
}
.main_form_body_voteBasic {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
}
.vote_type_desc {
  margin: 0px 30px;
  font-size: 10px;
}
.vote_fraction_box {
}
.vote_fraction_box .el-form-item__label {
  margin: 24px 0px 0px 0px;
}
</style>
